<script type="text/javascript">
import store from "../store/index";
import router from "../router/index";

// 定义函数
function testFun() {
  console.log("测试函数");
}

// 倒计时
function countDown(payEndTime, nowTime) {
  let end = new Date(payEndTime).getTime(); //1小时后  60分钟 * 60秒 * 1000  结束时间
  // console.log(end);
  // console.log(nowTime);
  let now;
  nowTime ? (now = nowTime) : (now = new Date().getTime()); //当前时间
  let leftTime = end - now; // 结束秒数 - 现在秒数
  let d, h, m, s;
  if (leftTime > 0) {
    d = Math.floor(leftTime / 1000 / 60 / 60 / 24);
    h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
    m = Math.floor((leftTime / 1000 / 60) % 60);
    s = Math.floor((leftTime / 1000) % 60);
    // console.log(d + "天" + h + '小时' + m + '分钟' + s + '秒');
    let data = {
      d: d < 10 ? "0" + d : d,
      h: h < 10 ? "0" + h : h,
      m: m < 10 ? "0" + m : m,
      s: s < 10 ? "0" + s : s,
    };
    return data;
  }
}

//生成指定长度，指定基数的id
function uuid(len, radix) {
  var chars =
    "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split("");
  var uuid = [],
    i;
  radix = radix || chars.length;

  if (len) {
    // Compact form
    for (i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)];
  } else {
    // rfc4122, version 4 form
    var r;

    // rfc4122 requires these characters
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = "-";
    uuid[14] = "4";

    // Fill in random data. At i==19 set the high bits of clock sequence as
    // per rfc4122, sec. 4.1.5
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | (Math.random() * 16);
        uuid[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r];
      }
    }
  }

  return uuid.join("");
}

// 身份证保密处理
function sfzbm(i) {
  return i.idNumber.substr(0, 8) + "*****" + i.idNumber.substr(14);
}

// 封装页面跳转
function goUrl(type, url, params) {
  if (type == "replace") {
    router.replace({
      path: url,
      query: params,
    });
  } else if (type == "back") {
    if (window.history.length <= 1) {
      router.push({path:'/'})
    } else {
      router.back();
    }
  } else if (type == "jump") {
    router.push({
      name: url,
      params: params,
    });
  } else {
    router.push({
      path: url,
      query: params,
    });
  }
}

// 动态加载多图
function loadMulitImg(mulitImg) {
  return new Promise((resolve, reject) => {
    var img = [];
    var flag = 0;
    var imgTotal = mulitImg.length;
    for (var i = 0; i < imgTotal; i++) {
      img[i] = new Image();
      img[i].src = mulitImg[i].url;
      img[i].onload = function () {
        //第i张图片加载完成
        flag++;
        if (flag == imgTotal) {
          //全部加载完成
          resolve(img);
        }
      };
    }
  });
}

// 动态加载单图
function loadSingleImg(imgUrl) {
  return new Promise((resolve, reject) => {
    var img = new Image();
    img.crossOrigin = "Anonymous";
    img.src = imgUrl;
    img.onload = function () {
      resolve(img);
    };
  });
}

//下载图片、文件等
export const downLoad = (downloadName, url) => {
  const tag = document.createElement("a");
  tag.setAttribute("download", downloadName.replace(/\./g, "。"));
  tag.href = url;
  console.log(tag);
  tag.click();
};

//base64 转 file对象
export const base64_to_file = (dataurl, filename) => {
  //将base64转换为文件
  var arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, {
    type: mime,
  });
};

//时间转换
export const parseTime = (time) => {
  if (!time) {
    return {};
  }
  var live_time = time.replace(/-/g, "/"); //兼容ios
  var live_tive_stamp = new Date(live_time).getTime();
  var date = new Date(live_tive_stamp);
  var Y = date.getFullYear();
  var M =
    date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1;
  var D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
  var h = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
  var m = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
  return { Y, M, D, h, m };
};

//判断是否为空
const isEmpty = (str) => {
  if (str) {
    var str_type = typeof str;
    if (str_type == "object") {
      //要判断的是【对象】或【数组】或【null】等
      if (typeof str.length == "undefined") {
        if (JSON.stringify(str) == "{}") {
          return true; //空值，空对象
        }
      } else if (str.length == 0) {
        return true; //空值，空数组
      }
    } else if (str_type == "string") {
      //如果要过滤空格等字符
      var new_str = str.trim();
      if (new_str.length == 0) {
        //空值，例如:带有空格的字符串" "。
        return true;
      }
    } else if (str_type == "boolean") {
      if (!str) {
        return true;
      }
    } else if (str_type == "number") {
      if (!str) {
        return true;
      }
    }
    return false; //非空值
  } else {
    //空值,例如：
    //(1)null
    //(2)可能使用了js的内置的名称，例如：var name=[],这个打印类型是字符串类型。
    //(3)空字符串''、""。
    //(4)数字0、00等，如果可以只输入0，则需要另外判断。
    return true;
  }
};

//js将对象转为键值对，key1=val1&key2=val2
const serialize = function (obj, prefix) {
  var str = [],
    p;
  for (p in obj) {
    if (obj.hasOwnProperty(p)) {
      var k = prefix ? prefix + "[" + p + "]" : p,
        v = obj[p];
      str.push(
        v !== null && typeof v === "object"
          ? serialize(v, k)
          : encodeURIComponent(k) + "=" + encodeURIComponent(v)
      );
    }
  }
  return str.join("&");
};

//获取唯一ID
const uniqueID = function (len, radix) {
  var chars =
    "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split("");
  var uuid = [],
    i;
  radix = radix || chars.length;

  if (len) {
    // Compact form
    for (i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)];
  } else {
    // rfc4122, version 4 form
    var r;

    // rfc4122 requires these characters
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = "-";
    uuid[14] = "4";

    // Fill in random data. At i==19 set the high bits of clock sequence as
    // per rfc4122, sec. 4.1.5
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | (Math.random() * 16);
        uuid[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r];
      }
    }
  }

  return uuid.join("");
};

//获取随机数 值大于等于min，小于max
const rand = function (min, max) {
  return Math.floor(Math.random() * (min - max)) + max;
};

//组装头像
const dealImg = function (path, default_img) {
  // var url = "http://r3mq39p5e.hn-bkt.clouddn.com/";   //测试
  var url = "http://qiniuyundun.xinyuhealth.com/";    //正式
  if (path) {
    return url + path;
  } else {
    return default_img;
  }
};

//数组去空
const rmEmpty = function (arr) {
  if (isEmpty(arr)) {
    return [];
  }
  var arr1 = [];
  arr.map((r) => {
    if (!isEmpty(r)) {
      arr1.push(r);
    }
  });
  return arr1;
};

const parseObj = function (obj) {
  return JSON.parse(JSON.stringify(obj));
};

//获取二维数组中的一项的值，根据另一个
const getArrLabel = function (obj, key, value, okey) {
  var val = null;
  obj.map((r) => {
    if (r[key] == value) {
      val = r[okey];
    }
  });
  return val;
};

//多久以前，时间处理
const timeAgo = function (dateTime) {
  //dateTimeStamp是一个时间毫秒，注意时间戳是秒的形式，在这个毫秒的基础上除以1000，就是十位数的时间戳。13位数的都是时间毫秒。
  var dateTimeStamp = new Date(dateTime).getTime();
  var minute = 1000 * 60; //把分，时，天，周，半个月，一个月用毫秒表示
  var hour = minute * 60;
  var day = hour * 24;
  var week = day * 7;
  var halfamonth = day * 15;
  var month = day * 30;
  var now = new Date().getTime(); //获取当前时间毫秒
  console.log(now);
  var diffValue = now - dateTimeStamp; //时间差

  if (diffValue < 0) {
    return;
  }
  var result;
  var minC = diffValue / minute; //计算时间差的分，时，天，周，月
  var hourC = diffValue / hour;
  var dayC = diffValue / day;
  var weekC = diffValue / week;
  var monthC = diffValue / month;
  //此处考虑小数情况，感谢 情非得已https://blog.csdn.net/weixin_48495574 指正
  if (monthC >= 1 && monthC < 4) {
    result = " " + parseInt(monthC) + "月前";
  } else if (weekC >= 1 && weekC < 4) {
    result = " " + parseInt(weekC) + "周前";
  } else if (dayC >= 1 && dayC < 7) {
    result = " " + parseInt(dayC) + "天前";
  } else if (hourC >= 1 && hourC < 24) {
    result = " " + parseInt(hourC) + "小时前";
  } else if (minC >= 1 && minC < 60) {
    result = " " + parseInt(minC) + "分钟前";
  } else if (diffValue >= 0 && diffValue <= minute) {
    result = "刚刚";
  } else {
    var dt = parseTime(dateTime);
    result = dt.Y + "-" + dt.M + "-" + dt.D + " " + dt.h + ":" + dt.m;
  }
  return result;
};

//按照字符串顺序排序
const stringSort = (list, property) => {
  var strFun = function (property) {
    return function (a, b) {
      var value1 = a[property].charCodeAt(0);
      var value2 = b[property].charCodeAt(0);
      return value1 - value2;
    };
  };
  return list.sort(strFun(property));
};

//判断是否是手机
const isMobile = () => {
  if(/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)){
    return true;
  }else if(/(Android)/i.test(navigator.userAgent)){
    return true;
  }else{
    return false;
  }
};

//提取富文本内容
const getText = (str) => {
  return str
    .replace(/<[^<>]+>/g, "")
    .replace(/&nbsp;/gi, "");
}

// 暴露出这些方法
export default {
  getText,
  isMobile,
  testFun,
  countDown,
  sfzbm,
  uuid,
  goUrl,
  loadMulitImg,
  loadSingleImg,
  downLoad,
  base64_to_file,
  parseTime,
  isEmpty,
  serialize,
  uniqueID,
  rand,
  dealImg,
  rmEmpty,
  parseObj,
  getArrLabel,
  timeAgo,
  stringSort,
};
</script>



// WEBPACK FOOTER //
// src/common/function.vue